import type {HeaderSectionContentModel} from '@/types/content';
import {twx} from '@/utils/tailwindUtils';

type HeaderSectionProps = {
    content?: HeaderSectionContentModel | null;
};

const HeaderSection = ({content}: HeaderSectionProps) => {
    const {title, description} = content ?? {};

    if (!title && !description) return null;

    return (
        <header className={twx('flex flex-col gap-2 pb-2', !description && 'pb-4')}>
            {title && <h1 className='m-0 font-bold text-32 leading-125'>{title}</h1>}
            {description && <p className='m-0 text-16 text-romance leading-15'>{description}</p>}
        </header>
    );
};

export default HeaderSection;
